<template>
  <div class="wrapper">
    <div class="title">{{title}}</div>
    <div class="subtitle">{{subtitle}}</div>
    <div class="sub">
      <div class="date">{{date}}</div>
      <div class="view"><img src="../../assets/images/view.png" alt=""> {{page_view > 999 ? Math.floor(page_view/100)/10+'K' : page_view}}</div>
    </div>
    <div class="content" v-html="content"></div>
  </div>
</template>

<script>
import md5 from 'js-md5'
import utils from '../../utils/index'
export default {
  data(){
    return {
      id: 0,
      title: "",
      subtitle: "",
      date: "",
      page_view: "",
      content: ""
    }
  },
  mounted(){
    let that = this
    this.id = this.$route.params.id
    let req = {
      id: parseInt(this.id)
    }
    let time = utils.getts()
    let token = md5("BLUE" + time + "SHARK")
    let header = {
      headers: {
        Authorization: "Bearer " + token,
        Ts: time,
        SGAGENT: PKG_NAME
      }
    }
    this.$http.post(API_HOST+"/web/api/v1/article/info",JSON.stringify(req),header).then((res)=>{
      let data = res.body
      if(data.state == 0){
        that.title = data.data.title
        that.subtitle = data.data.about
        that.date = utils.getDate(data.data.publish_at)
        that.page_view = data.data.page_view
        that.content = data.data.content
      }
    })
  }
}
</script>

<style lang="less" scoped>
.wrapper{
  padding: 20px;
  .title{
    font-size: 17px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .subtitle{
    font-size: 16px;
    color: #999;
    margin-bottom: 5px;
  }
  .sub{
    display: flex;
    display: -webkit-flex;
    .date{
      flex: 1;
      font-size: 14px;
      color: #969696;
      margin-bottom: 5px;
    }
    .view{
      color: #969696;
      font-size: 12px;
      img{
        width: 22px;
        vertical-align: middle;
        margin-bottom: 3px;
      }
    }
  }
  .content{
    text-align: justify;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/find/detail.vue